import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_BENEFIT_REQUEST = "GET_BENEFIT_REQUEST";
export const GET_BENEFIT_SUCCESS = "GET_BENEFIT_SUCCESS";
export const GET_BENEFIT_ERROR = "GET_BENEFIT_ERROR";

//* ACTIONS ------------------------------------------------
export const getBenefitRequest = (payload = {}, callback) => ({
  type: GET_BENEFIT_REQUEST,
  payload,
  callback,
});

export const getBenefitSuccess = (data) => ({
  type: GET_BENEFIT_SUCCESS,
  payload: data,
});

export const getBenefitError = (error) => ({
  type: GET_BENEFIT_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getBenefitServiceRequest = async (benefitId) => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/benefits/${benefitId}`, options);
};
